var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cached-terms"}},[_c('ul',_vm._l((_vm.cachedTerms),function(term,index){return _c('li',{on:{"click":function($event){_vm.suggestionClick(term)}}},[_c('p',[_vm._v(_vm._s(term.query.toLowerCase())+" "),_c('small',[_vm._v(_vm._s(term.method))])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b9ba008","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/engagement/cachedterms/CachedTerms.vue
// module id = 807
// module chunks = 1